<div class="no-access-page">
  <div class="no-access-card">
    <h1>{{ title }}</h1>
    <p class="no-access-description">{{ description }}</p>
    <div class="no-access-actions">
      <a class="no-access-btn" [href]="partnerPortalUrl" rel="noreferrer">
        {{ cta }}
      </a>
    </div>
  </div>
</div>
